export const routes = {
  dimensions: 'dimensions',
  calculation: 'calculation',
  error: 'error',
};
